import PayrollFailedPaymentBanner from './PayrollFailedPaymentBanner';

export default PayrollFailedPaymentBanner;
